import React, { useState, useEffect } from 'react';
import './style.css';
import { FaBars, FaTimes } from 'react-icons/fa';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';

function Header() {
  const [menuExpanded, setMenuExpanded] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const toggleMenu = () => {
    setMenuExpanded(prev => !prev);
  };

  useEffect(() => {
    console.log('Header foi renderizado');
  }, []);

  const handleSair = () => {
    setMenuExpanded(false);
    try {
      localStorage.clear();
      sessionStorage.clear();
    } catch { /* ignore */ }
    navigate('/', { replace: true });
  };

  return (
    <header className="header">
      <input
        type="checkbox"
        id="check"
        checked={menuExpanded}
        onChange={toggleMenu}
      />
      <label htmlFor="check" className="nav-icons">
        {menuExpanded ? <FaTimes id="close-icon" /> : <FaBars id="menu-icon" />}
      </label>

      <nav className={`menu-h ${menuExpanded ? 'expandir' : ''}`} id="menu-h">
        <Link
          to="/dashboard"
          className="dropdown voltar"
          onClick={(e) => {
            setMenuExpanded(false);
            try {
              const tk = localStorage.getItem('token');
              if (tk) {
                const dec = jwtDecode(tk);
                if (
                  dec?.tipo === 'estudante' ||
                  Number(dec?.acesso_autorizacao ?? 0) === 1
                ) {
                  e.preventDefault();
                  const tp = Number(dec?.tipo_programa ?? 0);
                  navigate(tp === 2 ? '/tca-empregador' : '/tce');
                }
              }
            } catch (_) {
            }
          }}
        >
          Home
        </Link>
        <Link
          to="/historico-eventos"
          className="dropdown estudante"
          onClick={() => setMenuExpanded(false)}
        >
          Histórico
        </Link>
        <Link
          to="/acompanhamento"
          className="dropdown unidade"
          onClick={() => {
            setMenuExpanded(false);
            if (location.pathname.startsWith('/tce')) {
              try {
                sessionStorage.setItem('modulo_ativo', 'tce');
                localStorage.setItem('ultimo_modulo_acessado', 'tce');
                localStorage.setItem('origem_modulo', 'tce');
              } catch (_) {}
            } else if (location.pathname.startsWith('/tca-empregador')) {
              try {
                sessionStorage.setItem('modulo_ativo', 'tca-empregador');
                localStorage.setItem('ultimo_modulo_acessado', 'tca-empregador');
                localStorage.setItem('origem_modulo', 'tca-empregador');
              } catch (_) {}
            } else if (location.pathname.startsWith('/tca')) {
              try {
                sessionStorage.setItem('modulo_ativo', 'tca');
                localStorage.setItem('ultimo_modulo_acessado', 'tca');
                localStorage.setItem('origem_modulo', 'tca');
              } catch (_) {}
            }
          }}
        >
          Acompanhamento
        </Link>
        <button
          type="button"
          className="dropdown header-sair-btn"
          onClick={handleSair}
        >
          Sair
        </button>
      </nav>
    </header>
  );
}

export default Header;
